import DashboardScreenConnector from './DashboardScreenConnector';

export default DashboardScreenConnector;
